import PropTypes from 'prop-types';
import Constants from '../../flux/Constants';

const ActorChatRatingPropType = PropTypes.shape({
	[Constants.ChatRatings.LAST_NINETY_DAYS]: PropTypes.shape({
		satisfactionRate: PropTypes.number,
		countRatings: PropTypes.number,
	}),
});

export default ActorChatRatingPropType;
